import { Currency } from '@tradecafe/types/core'

export interface AmountMaskOptions {
  prefix: string
  thousandSeparator: string
  decimalMarker: '.' | ','
}

// ngx-mask only strips separators listed in its specialCharacters, which contain a plain space but not NBSP/NNBSP
export function parseAmountMaskOptions(currency: Currency | undefined, locale?: string): AmountMaskOptions {
  const parts = new Intl.NumberFormat(locale).formatToParts(1234567.89)
  const group = parts.find(p => p.type === 'group')?.value ?? ','
  const decimal = parts.find(p => p.type === 'decimal')?.value
  return {
    prefix: currency ? `${currency.symbol || currency.code || ''} ` : '',
    thousandSeparator: /\s/.test(group) ? ' ' : group,
    decimalMarker: decimal === ',' ? ',' : '.',
  }
}

export function amountMaskToNumber(value: string | number | null | undefined): number | null {
  if (value === '' || value === null || value === undefined) return null
  const n = Number(value)
  return Number.isNaN(n) ? null : n
}
